import CityPage from "../CityPage";

export default function Mokena() {
  return <CityPage slug="mokena" />;
}
